<template>
  <div class="flex-grow-1 d-flex flex-column overflow-y-hidden">
    <div class="a-header">
      <span class="a-header--title slide-down-enter-active">View Detail - {{ detailVerifyHistory.id }}</span>
    </div>
    <div class="a-body p-20-px flex-grow-1 d-flex flex-column">
      <a-form class="flex-grow-1">
        <div class="d-flex justify-content-center align-items-center pt-20-px" v-if="isLoading">
          <Spinner />
        </div>
        <transition name="slide-up">
          <div v-if="!isLoading">
            <template v-if="resultVerifyWebpage">
              <VerifyResult :result="resultVerifyWebpage" />
            </template>
            <!--
            <a-row :gutter="24">
              <a-col :span="12">
                  <a-form-item label="Webpage Name">
                    <div class="form-item-readonly text-truncate">
                      {{ detailVerifyHistory.webpageName }}
                    </div>
                  </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="Webpage URL">
                  <div class="form-item-readonly text-truncate">
                    {{ detailVerifyHistory.webpageUrl }}
                  </div>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="12">
                  <a-form-item label="Verify Result">
                    <div class="form-item-readonly text-truncate">
                      {{ detailVerifyHistory.verifyResult }}
                    </div>
                  </a-form-item>
              </a-col>
                <a-col :span="12">
                  <a-form-item label="Detected">
                    <div class="form-item-readonly">
                      <time>{{ detailVerifyHistory.detectedAt | dateString }}</time>
                      &nbsp;
                      <time>{{ detailVerifyHistory.detectedAt | timeString }}</time>
                    </div>
                  </a-form-item>
                </a-col>
            </a-row>
            <div class="info">
              <a-row :gutter="24">
                <a-col :span="24">
                  <a-form-item label="Title">
                    <div class="form-item-readonly">
                      {{ detailVerifyHistory.verifyTitle }}
                    </div>
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :span="24">
                  <a-form-item label="Hash">
                    <div class="form-item-readonly">
                      {{ detailVerifyHistory.verifyHash }}
                    </div>
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :span="24">
                  <a-form-item label="HREF Links">
                    <div class="form-item-readonly">
                      {{ detailVerifyHistory.verifyHrefCount }}
                    </div>
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :span="24">
                  <a-form-item label="Div Tags">
                    <div class="form-item-readonly">
                      {{ detailVerifyHistory.verifyDivisionCount }}
                    </div>
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :span="24">
                  <a-form-item label="Iframe Tags">
                    <div class="form-item-readonly">
                      {{ detailVerifyHistory.verifyIframeCount }}
                    </div>
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :span="24">
                  <a-form-item label="Links">
                    <div class="form-item-readonly">
                      {{ detailVerifyHistory.verifyLinkCount }}
                    </div>
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :span="24">
                  <a-form-item label="Image">
                    <div class="form-item-readonly">
                      {{ detailVerifyHistory.verifyImageCount }}
                    </div>
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :span="24">
                  <a-form-item label="Javascripts">
                    <div class="form-item-readonly">
                      {{ detailVerifyHistory.verifyScriptCount }}
                    </div>
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :span="24">
                  <a-form-item label="HTML Lines">
                    <div class="form-item-readonly">
                      {{ detailVerifyHistory.verifyLineNo }}
                    </div>
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :span="24">
                  <a-form-item label="Changes Detected">
                    <div class="form-item-readonly change-detect-box">
                      <div v-html="detailVerifyHistory.changesDetected"></div>
                    </div>
                  </a-form-item>
                </a-col>
              </a-row>
            </div>
            -->
          </div>
        </transition>
      </a-form>
    </div>
  </div>
</template>

<script>
  import PollingHistoryService from '../services/PollingHistory.service';
  import VerifyResult from "../../Webpages/components/VerifyResult";

  export default {
    name: 'VerifyHistoryDetail',
    components: {
      VerifyResult,
    },
    data() {
      return {
        isLoading: true,
        detailVerifyHistory: {
          id: '',
          webpageName: '',
          webpageUrl: '',
          detectedAt: '',
          verifyTitle: '',
          verifyHash: '',
          verifyLineNo: 0,
          verifyHrefCount: 0,
          verifyScriptCount: 0,
          verifyLinkCount: 0,
          verifyImageCount: 0,
          verifyDivisionCount: 0,
          verifyIframeCount: 0,
          verifyFormCount: 0,
          changesDetected: ''
        },
        resultVerifyWebpage: null,
      };
    },
    beforeMount() {
      this.detailVerifyHistory.id = this.$route.params.id;
    },
    mounted() {
      this.fetchDetailVerifyHistory();
    },
    methods: {
      async fetchDetailVerifyHistory() {
        try {
          const detailData = await PollingHistoryService.fetchDetailVerify(this.detailVerifyHistory.id);
          this.resultVerifyWebpage = detailData.structured_result;
          const {
            id,
            url: { name, url },
            started_at,
            title,
            hash,
            result,
            line_num,
            count_href,
            count_script,
            count_link,
            count_image,
            count_div,
            count_iframe,
            count_form,
            comment
          } = detailData;
          this.detailVerifyHistory = {
            id,
            webpageName: name || '',
            webpageUrl: url || '',
            detectedAt: started_at,
            verifyResult: result || '',
            verifyTitle: title || '',
            verifyHash: hash || '',
            verifyLineNo: line_num || 0,
            verifyHrefCount: count_href || 0,
            verifyScriptCount: count_script || 0,
            verifyLinkCount: count_link || 0,
            verifyImageCount: count_image || 0,
            verifyDivisionCount: count_div || 0,
            verifyIframeCount: count_iframe || 0,
            verifyFormCount: count_form || 0,
            changesDetected: comment || ''
          };
        } catch {
          this.$showErrorMessage('Error when loading detail history.');
        } finally {
          setTimeout(() => {
            this.isLoading = false;
          }, 300);
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  .a-body {
    max-height: calc(100% - 60px);
  }
  .info {
    background: #f7f7f7;
    padding: 0 20px;
    border-radius: 4px;
  }
  .form-item-readonly {
    word-break: break-word;
    font-size: 13px;
    padding: 0 11px;
    height: auto;
    min-height: 40px;
    color: rgba(0, 0, 0, 0.65);
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    background-color: transparent;
  }
  .change-detect-box {
    overflow-y: auto;
    max-height: 300px;
    div:first-child {
      line-height: 25px;
      padding: 5px 0px;
      white-space: pre-wrap;
    }
  }
</style>
